import React from 'react'
import { Tooltip } from 'antd'
import { navigate } from '@reach/router'
import { ContentContainer, TrendCount } from 'components'
import { ScanScore } from 'components/Score'
import { colors } from 'style/theme'
import styled from '@emotion/styled'
import Moment from 'react-moment'
import 'moment-timezone'
import ScanState from 'views/ScanSettings/Scans/components/ScanState'
import { limitStringLength } from '../../Scan/components/ScanWidgets'

const CompareCont = styled.div(() => ({
  display: 'grid',
  gridTemplateColumns: '80px 0.98fr'
}))

const StateAndDates = styled.div(() => ({
  display: 'grid',
  gridTemplateRows: '35px auto'
}))

const StyledScanState = styled.div(() => ({
  fontWeight: 700
}))

const Dates = styled.div(() => ({
  marginTop: '3%'
}))

const TitleCont = styled.div(() => ({
  fontSize: '0.7rem',
  fontWeight: 'bold'
}))

const DurationText = styled.span(() => ({
  color: 'gray'
}))

const SubTitle = styled.span(() => ({
  fontWeight: 500
}))

const ViewScanLink = styled.a(() => ({
  fontWeight: 500,
  textDecoration: 'underline'
}))

const GridCont = styled.div(() => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr'
}))

const durationFormating = (num) => {
  if (num < 1) return '1 Second'

  if (num > 1 && num < 60) return Math.round(num) + ' Seconds'

  if (num > 60) {
    num = num / 60
    if (num < 60) return Math.round(num) + ' Minutes'
    else return Math.round(num) + ' Hours'
  }
}

const CompareArea = (props) => {
  let path = `/scan-settings/${props.scanSettingsId}/scan/${props.scanId}`
  if (props.isDetailedView) {
    path += `?details=${props.documentId}`
  }
  return (
    <CompareCont>
      <ScanScore fontWeight="700" labelSize="1.5rem" width={50} score={props.score} thickness={9} />
      <StateAndDates>
        <StyledScanState>
          <ScanState state={props.fullStatus} pageCount={1} completedCount={1} />
        </StyledScanState>
        <Dates>
          <TitleCont>
            <SubTitle>Duration: </SubTitle>
            <DurationText>{props.duration}</DurationText>
          </TitleCont>
          <TitleCont>
            <SubTitle>Completed: </SubTitle>
            <DurationText>
              <Moment utc local fromNow>
                {props.endDate}
              </Moment>
            </DurationText>
          </TitleCont>
          <TitleCont>
            <ViewScanLink onClick={() => navigate(path, { replace: true })}>
              {props.isDetailedView ? 'VIEW DOCUMENT' : 'VIEW SCAN'}
            </ViewScanLink>
          </TitleCont>
        </Dates>
      </StateAndDates>
    </CompareCont>
  )
}

const getDuration = (stats, isDetailedView) => {
  let durationA = durationFormating(stats.scan_a_duration)
  let durationB = durationFormating(stats.scan_b_duration)
  if (isDetailedView) {
    durationA = durationFormating(stats.document_a_duration)
    durationB = durationFormating(stats.document_b_duration)
  }
  return [durationA, durationB]
}

const StyledUrlContainer = styled.div(() => ({
  textAlign: 'center',
  marginTop: '3%'
}))

const StyledUrl = styled.a(() => ({
  fontSize: '0.8rem',
  color: '#00a1ff',
  fontWeight: 700,
  textDecoration: 'underline'
}))

export default [
  {
    key: 'scan_a_score',
    width: '65%',
    render: (_, stats, isDetailedView, scanIds) => {
      let scoreA = stats && (stats.scan_a_score || stats.document_a_score)
      let scoreB = stats && (stats.scan_b_score || stats.document_b_score)
      let durationA = stats && getDuration(stats, isDetailedView)[0]
      let durationB = stats && getDuration(stats, isDetailedView)[1]
      let endDateA = stats && stats.scan_a_complete_date
      let endDateB = stats && stats.scan_b_complete_date
      let fullStatusA = stats && (stats.scan_a_state || stats.document_a_status)
      let fullStatusB = stats && (stats.scan_b_state || stats.document_b_status)
      let shortStatusA = fullStatusA && fullStatusA.split(' ')[0]
      let shortStatusB = fullStatusB && fullStatusB.split(' ')[0]
      let url = stats && stats.url
      return (
        <ContentContainer>
          <GridCont>
            <CompareArea
              title="A"
              score={scoreA}
              duration={durationA}
              endDate={endDateA}
              fullStatus={fullStatusA}
              shortStatus={shortStatusA}
              scanId={scanIds.scanA}
              scanSettingsId={scanIds.scanSettingsId}
              isDetailedView={isDetailedView}
              documentId={stats && stats.document_a_id}
            ></CompareArea>
            <CompareArea
              title="B"
              score={scoreB}
              duration={durationB}
              endDate={endDateB}
              fullStatus={fullStatusB}
              shortStatus={shortStatusB}
              scanId={scanIds.scanB}
              scanSettingsId={scanIds.scanSettingsId}
              isDetailedView={isDetailedView}
              documentId={stats && stats.document_b_id}
            ></CompareArea>
          </GridCont>

          {url && (
            <StyledUrlContainer>
              <Tooltip title={url} placement="bottom">
                <StyledUrl href={url} target="_blank">
                  {limitStringLength(url, 60)}
                </StyledUrl>
              </Tooltip>
            </StyledUrlContainer>
          )}
        </ContentContainer>
      )
    }
  },
  {
    dataKey: 'regression_count',
    render: (stats) => {
      const visible = stats && stats.visible_regressions
      const total = stats && stats.total_regressions
      return (
        <TrendCount title="REGRESSIONS" countValue={visible} markerColor={colors.error.color} totalErrors={total} />
      )
    }
  },
  {
    dataKey: 'fixed_count',
    render: (stats) => {
      const visible = stats && stats.visible_fixed
      const total = stats && stats.total_fixed
      return <TrendCount title="FIXED" countValue={visible} markerColor={colors.success.color} totalErrors={total} />
    }
  },
  {
    dataKey: 'no_change_count',
    render: (stats) => {
      const visible = stats && stats.visible_no_change
      const total = stats && stats.total_no_change
      return <TrendCount title="NO CHANGE" countValue={visible} markerColor={colors.brandGray} totalErrors={total} />
    }
  }
]
